<template>
    <div>
        <v-row align="center" class="mb-1">
            <v-col cols="10"> {{ typeMapping[selectedTab] }} Config </v-col>
            <v-col class="d-flex justify-end align-center" cols="2">
                <v-btn
                    small
                    color="blue-grey"
                    class="mr-2"
                    @click="getConfigData"
                    :loading="loading"
                    ><v-icon>mdi-refresh</v-icon></v-btn
                >
                <v-btn
                    small
                    color="primary"
                    class="mr-3"
                    @click="() => showDialog('add')"
                    :loading="loading"
                >
                    {{ $t("common.form.add") }}
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :items-per-page="15"
            :headers="header"
            :header-props="{ sortIcon: null }"
            :items="computedConfigData"
            :loading="loading"
            :footer-props="{
                'items-per-page-text': '',
            }"
            dense
        >
            <template v-slot:header.login="{ header }">
                {{ header.text }}
                <v-menu
                    v-model="loginSearchMenu"
                    offset-y
                    :close-on-content-click="false"
                    top
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click.prevent="onSearch('loginSearch')"
                            id="loginSearch"
                        >
                            mdi-magnify
                        </v-icon>
                    </template>
                    <div style="background-color: #1e1e1e; width: 280px">
                        <v-text-field
                            v-model="loginSearch"
                            class="px-4"
                            type="text"
                            ref="loginSearch"
                            :label="$t('alertHub.enterToSearch')"
                            style="width: 100%"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-btn
                            @click="
                                loginSearch = '';
                                loginSearchMenu = false;
                            "
                            small
                            text
                            color="red"
                            class="ml-2 mb-2"
                            style="padding: 6px"
                        >
                            {{ $t("common.form.clean") }}
                        </v-btn>
                    </div>
                </v-menu>
            </template>
            <template v-slot:header.expires_at="{ header }">
                {{ header.text }}
                <v-menu
                    v-model="filterMenu"
                    offset-y
                    :close-on-content-click="false"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on" id="filter">
                            mdi-filter
                        </v-icon>
                    </template>
                    <div style="background-color: #1e1e1e; width: 220px">
                        <v-list dense>
                            <v-list-item
                                v-for="option in expireOptions"
                                :key="option"
                                @click="toggleFilter(option)"
                            >
                                <v-list-item-action>
                                    <v-checkbox
                                        :input-value="
                                            selectedFilter.includes(option)
                                        "
                                        @click.stop="toggleFilter(option)"
                                    ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{
                                        capitalizeKey(option)
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-menu>
            </template>
            <template v-slot:item.server_id="{ item }">
                {{
                    !!serverData.find((data) => data.id === item.server_id)
                        ? serverData.find((data) => data.id === item.server_id)
                              .server_name
                        : item.server_id
                }}
            </template>
            <template v-slot:item.expires_at="{ item }">
                <v-chip x-small>
                    {{ capitalizeKey(item.expires_at) }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    class="mr-2"
                    @click="() => showDialog('edit', item)"
                    :disabled="loading"
                >
                    mdi-pencil
                </v-icon>
                <v-menu
                    :value="deletingItemId === item.id"
                    @input="
                        (v) => {
                            if (!v) deletingItemId = null;
                        }
                    "
                    :close-on-content-click="false"
                    offset-y
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            dense
                            :disabled="loading"
                            v-on="on"
                            @click="deletingItemId = item.id"
                            >mdi-delete</v-icon
                        >
                    </template>
                    <v-card class="pa-3" width="220">
                        <div class="text-body-2 mb-3">
                            Confirm to delete this configuration?
                        </div>
                        <div class="d-flex justify-end">
                            <v-btn
                                text
                                small
                                class="mr-1"
                                @click="deletingItemId = null"
                            >
                                {{ $t("common.form.cancel") }}
                            </v-btn>
                            <v-btn
                                color="error"
                                small
                                :loading="loading"
                                @click="deleteConfig(item)"
                            >
                                {{ $t("common.form.confirm") }}
                            </v-btn>
                        </div>
                    </v-card>
                </v-menu>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" width="700" persistent>
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        {{
                            editingMode !== "add"
                                ? $t("common.form.edit")
                                : $t("common.form.add")
                        }}{{ $t("common.word.configuration") }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="dialog = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-container class="px-6 pt-5 pb-2">
                    <v-row align="center" class="mb-1" v-if="editingItem">
                        <v-col cols="4" v-if="editingMode !== 'add'">
                            <span class="text-body-2 text--darken-2"> ID </span>
                        </v-col>
                        <v-col cols="8" v-if="editingMode !== 'add'">
                            <v-text-field
                                :value="editingItem['id']"
                                dense
                                hide-details
                                readonly
                            />
                        </v-col>
                        <v-col cols="4">
                            <span class="text-body-2 text--darken-2">
                                {{ $t("common.table.alertType") }}
                            </span>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-if="editingMode !== 'add'"
                                :value="
                                    typeTableNameMapping[
                                        editingItem['alert_type']
                                    ]
                                "
                                dense
                                hide-details
                                readonly
                            />
                            <v-autocomplete
                                v-else
                                v-model="editingItem['alert_type']"
                                :items="alertTypeOptions"
                                item-text="title"
                                item-value="value"
                                chips
                                dense
                                hide-details
                                required
                                small-chips
                                multiple
                            />
                        </v-col>
                        <v-col cols="4">
                            <span class="text-body-2 text--darken-2">
                                {{ $t("common.table.server") }}
                            </span>
                        </v-col>
                        <v-col cols="8">
                            <v-autocomplete
                                v-model="editingItem['server_id']"
                                :items="serverData"
                                @change="
                                    (e) => {
                                        editingItem['server_id'] = e;
                                    }
                                "
                                item-text="server_name"
                                item-value="id"
                                chips
                                dense
                                hide-details
                                required
                                small-chips
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                            <span class="text-body-2 text--darken-2">
                                {{ $t("common.table.login") }}
                            </span>
                        </v-col>
                        <v-col cols="8">
                            <v-autocomplete
                                :items="loginOptions"
                                :disabled="!editingItem['server_id']"
                                required
                                dense
                                :multiple="editingMode === 'add'"
                                clearable
                                hide-details
                                item-text="name"
                                item-value="name"
                                small-chips
                                v-model="editingItem['login']"
                            />
                        </v-col>
                        <v-col cols="4">
                            <span class="text-body-2 text--darken-2">
                                Expires At
                            </span>
                        </v-col>
                        <v-col cols="8">
                            <v-radio-group
                                v-model="editingItem['expires_at']"
                                row
                                hide-details
                            >
                                <v-radio label="Today" value="today"></v-radio>
                                <v-radio label="Never" value="never"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-6 py-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        small
                        @click="dialog = false"
                        :loading="loading"
                    >
                        {{ $t("common.form.cancel") }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        small
                        @click="submit"
                        :loading="loading"
                    >
                        {{ $t("common.form.submit") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { snackbar } from "@components/mixins/snackbar";
import { createCancelToken } from "@utils/request";
import {
    getAlertHubConfigWithCancelToken,
    createAlertHubConfig,
    updateAlertHubConfig,
    deleteAlertHubConfig,
} from "@services/alert/config";
import deepClone from "deep-clone";
import { helper } from "@components/mixins/helper";

export default {
    mixins: [snackbar, helper],
    props: {
        selectedTab: "",
    },
    data() {
        return {
            typeMapping: {
                "Fast Trade": "Whitelist",
                "High Volume USD": "Whitelist",
                "High Trades": "Whitelist",
                "Large PNL": "Whitelist",
                "Low Liquidity Arbitrage": "Whitelist",
            },
            typeTableNameMapping: {
                MSG_TYPE_MONITOR_FAST_CLOSED_TRADE: "Fast Trade",
                MSG_TYPE_MONITOR_HIGH_VOLUME_USD: "High Volume USD",
                MSG_TYPE_MONITOR_HIGH_TRADE_COUNT: "High Trades",
                MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL: "Large PNL",
                MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE:
                    "Low Liquidity Arbitrage",
            },
            alertTypeOptions: [
                {
                    title: "Fast Trade",
                    value: "MSG_TYPE_MONITOR_FAST_CLOSED_TRADE",
                },
                {
                    title: "High Volume USD",
                    value: "MSG_TYPE_MONITOR_HIGH_VOLUME_USD",
                },
                {
                    title: "High Trades",
                    value: "MSG_TYPE_MONITOR_HIGH_TRADE_COUNT",
                },
                {
                    title: "Large PNL",
                    value: "MSG_TYPE_MONITOR_TODAY_OPENED_LARGE_PNL",
                },
                {
                    title: "Low Liquidity Arbitrage",
                    value: "MSG_TYPE_MONITOR_LOW_LIQUIDITY_ARBITRAGE",
                },
            ],
            loading: false,
            header: [
                {
                    text: "Id",
                    value: "id",
                },
                {
                    text: this.$t("common.table.server"),
                    value: "server_id",
                },
                {
                    text: this.$t("common.table.login"),
                    value: "login",
                },
                {
                    text: "Expires At",
                    value: "expires_at",
                },
                {
                    text: this.$t("common.table.createdAt"),
                    value: "created_at",
                },
                {
                    text: this.$t("common.table.updatedAt"),
                    value: "updated_at",
                },
                {
                    text: this.$t("common.table.actions"),
                    value: "actions",
                    sortable: false,
                    fixed: true,
                },
            ],
            configData: [],
            cancelTokenSource: null,
            dialog: false,
            editingMode: undefined,
            editingItem: null,
            loginOptions: [],
            deletingItemId: null,
            loginSearch: "",
            loginSearchMenu: false,
            filterMenu: false,
            selectedFilter: [],
            expireOptions: ["never", "today"],
            originalEditingServerLogin: undefined,
        };
    },
    computed: {
        ...mapState("Config", ["options"]),
        ...mapState("SettingsServer", ["serverData"]),
        computedConfigData() {
            return this.configData
                .filter((data) => {
                    return data.login.toString().includes(this.loginSearch);
                })
                .filter((item) =>
                    this.selectedFilter.length
                        ? this.selectedFilter.includes(item.expires_at)
                        : true
                );
        },
    },
    watch: {
        "editingItem.server_id"(nv) {
            this.loginOptions = this.options.filter_login.filter(
                (item) => item.server_id === nv
            );
        },
        selectedTab(nv) {
            if (nv) {
                this.configData = [];
                this.getConfigData();
            }
        },
    },
    methods: {
        getConfigData() {
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel(
                    this.$t("message.operationCanceled")
                );
            }

            this.cancelTokenSource = createCancelToken();

            this.loading = true;
            getAlertHubConfigWithCancelToken(
                { alert_type: this.selectedTab },
                this.cancelTokenSource
            )
                .then((res) => {
                    this.configData = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showDialog(mode, item) {
            this.editingItem = null;
            this.loginOptions = [];
            this.dialog = true;
            if (mode === "add") {
                this.editingMode = "add";
                this.editingItem = {
                    alert_type: [
                        Object.keys(this.typeTableNameMapping).find(
                            (key) =>
                                this.typeTableNameMapping[key] ===
                                this.selectedTab
                        ),
                    ],
                    server_id: undefined,
                    login: [],
                    expires_at: "never",
                };
            } else {
                this.editingMode = "update";
                this.originalEditingServerLogin =
                    item.server_id + "_" + item.login;
                const cloneItem = deepClone(item);
                cloneItem.login = cloneItem.login.toString();
                this.editingItem = cloneItem;
                this.loginOptions = this.options.filter_login.filter(
                    (item) => item.server_id === cloneItem.server_id
                );
            }
        },
        deleteConfig(item) {
            this.loading = true;
            deleteAlertHubConfig({ id: item.id }).then((res) => {
                this.snackBarSuccess(res.data.msg);
                this.deletingItemId = null;
                this.getConfigData(this.selectedTab);
            });
        },
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        toggleFilter(name) {
            const index = this.selectedFilter.indexOf(name);
            if (index > -1) {
                this.selectedFilter.splice(index, 1);
            } else {
                this.selectedFilter.push(name);
            }
        },
        submit() {
            if (this.editingMode === "add") {
                this.loading = true;
                const param = this.editingItem;
                createAlertHubConfig(param).then((res) => {
                    this.snackBarSuccess(res.data.msg);
                    this.dialog = false;
                    this.getConfigData(this.selectedTab);
                });
            } else {
                const existingLogins = this.configData
                    .map((data) => data.server_id + "_" + data.login.toString())
                    .filter((item) => item !== this.originalEditingServerLogin);
                if (
                    existingLogins.includes(
                        this.editingItem.server_id +
                            "_" +
                            this.editingItem.login.toString()
                    )
                ) {
                    this.snackBarDanger(
                        "Login already exists. Please double check and try again."
                    );
                    return;
                }
                this.loading = true;
                const param = {
                    id: this.editingItem.id,
                    alert_type: this.editingItem.alert_type,
                    server_id: this.editingItem.server_id,
                    login: this.editingItem.login,
                    expires_at: this.editingItem.expires_at,
                };
                updateAlertHubConfig(param).then((res) => {
                    this.snackBarSuccess(res.data.msg);
                    this.dialog = false;
                    this.getConfigData(this.selectedTab);
                });
            }
        },
    },
};
</script>
